export default "__VITE_ASSET__Rlzp0kNc__"